import { computed, Directive, effect, HostListener, inject, input, signal } from '@angular/core';
import { Nullable } from 'primeng/ts-helpers';
import { ThemeService } from '../../../../whitelabel/services/theme.service';

@Directive({
  selector: 'google-map[ospMapDefaultOptions]',
  standalone: true
})
export class MapDefaultOptionsDirective {
  private themeService = inject(ThemeService);
  private theme = signal(this.themeService.getTheme(this.themeService.getCurrentTheme()));
  private map: google.maps.Map | Nullable;

  $mapTypeControl = input(false, { alias: 'mapTypeControl' });
  $mapTypeControlPosition = input<google.maps.ControlPosition | undefined>(
    google.maps.ControlPosition.TOP_LEFT,
    { alias: 'mapTypeControlPosition' }
  );
  $zoomControl = input(false, { alias: 'zoomControl' });
  $zoomControlPosition = input<google.maps.ControlPosition | undefined>(
    google.maps.ControlPosition.RIGHT_BOTTOM,
    { alias: 'zoomControlPosition' }
  );

  private mapOptions = computed<google.maps.MapOptions>(() => ({
    mapTypeControl: this.$mapTypeControl(),
    mapTypeControlOptions: {
      position: this.$mapTypeControlPosition(),
      mapTypeIds: ['roadmap', 'hybrid'],
    },
    zoomControl: this.$zoomControl(),
    zoomControlOptions: {
      position: this.$zoomControlPosition(),
    },
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
    cameraControl: false,
    streetViewControl: false,
    controlSize: 32,
    restriction: { strictBounds: true, latLngBounds: { north: 85, south: -85, west: -180, east: 180 } },
    styles: this.theme().mapColors,
  }));

  constructor() {
    effect(() => {
      const options = this.mapOptions();
      this.applyMapOptions(options);
    });
  }

  @HostListener('mapInitialized', ['$event'])
  onMapReady(map: google.maps.Map): void {
    this.map = map;
    this.applyMapOptions(this.mapOptions());
  }

  private applyMapOptions(options: google.maps.MapOptions): void {
    if (this.map) {
      this.map.setOptions(options);
    }
  }

}
